import styled from 'styled-components';
import { Divider } from '@mui/material';
import colors from '../../../../styles/colors';
import Button from '../../../../components/Button';

const ReplyMessageContainer = styled.div`
  position: relative;
  padding: 6px 10px;
  width: 100%;
  background-color: ${colors.shades.secondary6};
`;

const ReplyMessageContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 1.6rem;
`;

const ReplyMessage = styled.div`
  font-weight: 400;
  font-size: 10px;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  margin: 4px 0 0 2px;
  color: ${colors.shades.secondary3};
`;

const ReplyDescription = styled.span`
  color: ${colors.base.secondary2};
  font-size: 9px;
  font-weight: 500;
  margin-top: -12px;
  background-color: ${colors.base.alpha};
  height: fit-content;
`;

const ReplyMessageInternalTextWarning = styled.div`
  color: ${colors.shades.danger3};
  background-color: ${colors.shades.primary7};
  line-height: 1.25em;
  border-radius: 2em;
  margin: 0.25em 0;
  font-size: 12px;
  font-weight: 500;
  padding: 0 10px;
`;

const MultiResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const MultiResponseItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const MultiResponseKey = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${colors.base.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 4px;

  &::before {
    content: "📝";
    font-size: 10px;
  }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-top: 8px;
`;

const InputLabel = styled.span`
  position: absolute;
  top: -8px;
  left: 8px;
  background: white;
  padding: 0 4px;
  font-size: 11px;
  font-weight: 600;
  z-index: 1;
`;

const MultiResponseInput = styled.div`
  width: 100%;
  min-height: 60px;
  padding: 8px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 4px;
  font-size: 12.5px;
  font-family: inherit;
  resize: vertical;
  outline: none;
`;

const StyledDivider = styled(Divider)`
  margin: 4px 0 8px 0;
  background-color: #D3E9E0;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;
`;

const InsertButton = styled.button`
  flex: 0 0 56%;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  padding: ${(props) => props.padding || '10px 14px'};
  border-radius: 5px;
  background-color: ${(props) => props.backgroundColor || 'transparent'};
  border: none;
  color: ${(props) => props.color || 'white'};
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
`;

const StyledActionButton = styled(Button)`
  background-color: ${colors.base.primary};
  color: ${colors.base.beta};
  border: 1.5px solid ${colors.shades.primary2};
  font-size: 12px;
  font-weight: bold;
  padding: 1px 10px;
  border-radius: 5px;
  cursor: pointer;

  :disabled {
    background-color: ${colors.base.primary};
    cursor: default;
  }
`;

const ScheduleQueueButton = styled(Button)`
  background-color: ${({ $queued }) => ($queued ? colors.base.secondary2 : 'transparent')};
  color: ${({ $queued }) => ($queued ? 'white' : colors.base.secondary2)};
  border: 1.5px solid ${colors.base.secondary2};
  font-size: 12px;
  font-weight: bold;
  padding: 1px 6px;
  border-radius: 5px;
  cursor: pointer;
`;

export {
  ReplyMessageContainer,
  ReplyMessageContent,
  ReplyMessage,
  ReplyDescription,
  ReplyMessageInternalTextWarning,
  MultiResponseContainer,
  MultiResponseItem,
  MultiResponseKey,
  MultiResponseInput,
  ButtonsContainer,
  StyledActionButton,
  StyledDivider,
  InsertButton,
  ScheduleQueueButton,
  InputContainer,
  InputLabel,
};
